export default __webpack_public_path__ + "static/media/manWithDog.3fca1bea.jpg";